var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentiaExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1816",
    "data-name": "Grupo 1816",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 74.675,
    viewBox: "0 0 118 74.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1260",
    "data-name": "Ret\\xE2ngulo 1260",
    width: 118,
    height: 74.675,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_753",
    "data-name": "Caminho 753",
    d: "M.043,328.565v17.5H12.032v-2.7H3.112v-4.853h8.736v-2.7H3.112v-4.538h8.92v-2.7Z",
    transform: "translate(-0.038 -288.697)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1815",
    "data-name": "Grupo 1815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1814",
    "data-name": "Grupo 1814",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_754",
    "data-name": "Caminho 754",
    d: "M117.2,339.337a7.548,7.548,0,0,0,5.535,2.414c2.518,0,3.515-1.233,3.515-2.387,0-1.574-1.863-2.046-3.988-2.6-2.859-.708-6.217-1.548-6.217-5.247,0-2.886,2.545-5.115,6.375-5.115a9.1,9.1,0,0,1,6.558,2.44l-1.758,2.282a7.113,7.113,0,0,0-5.063-1.994c-1.81,0-2.964.866-2.964,2.177,0,1.364,1.784,1.81,3.856,2.335,2.886.735,6.322,1.627,6.322,5.43,0,2.912-2.046,5.4-6.768,5.4a9.361,9.361,0,0,1-7.109-2.781Z",
    transform: "translate(-101.478 -286.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    "data-name": "Caminho 755",
    d: "M245.616,339.337a7.548,7.548,0,0,0,5.535,2.414c2.518,0,3.515-1.233,3.515-2.387,0-1.574-1.863-2.046-3.988-2.6-2.859-.708-6.217-1.548-6.217-5.247,0-2.886,2.545-5.115,6.375-5.115a9.1,9.1,0,0,1,6.558,2.44l-1.758,2.282a7.113,7.113,0,0,0-5.063-1.994c-1.81,0-2.964.866-2.964,2.177,0,1.364,1.784,1.81,3.856,2.335,2.886.735,6.322,1.627,6.322,5.43,0,2.912-2.046,5.4-6.768,5.4a9.361,9.361,0,0,1-7.109-2.781Z",
    transform: "translate(-214.315 -286.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_756",
    "data-name": "Caminho 756",
    d: "M381.627,328.565h11.989v2.7H384.7v4.538h8.736v2.7H384.7v4.853h8.919v2.7H381.627Z",
    transform: "translate(-335.321 -288.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_757",
    "data-name": "Caminho 757",
    d: "M509.441,333.314v12.75h-3.069v-17.5h3.148l8.946,12.408V328.566h3.069v17.5H518.57Z",
    transform: "translate(-444.93 -288.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_758",
    "data-name": "Caminho 758",
    d: "M658.034,331.267h-5.3v-2.7H666.4v2.7h-5.3v14.8h-3.069Z",
    transform: "translate(-573.533 -288.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1258",
    "data-name": "Ret\\xE2ngulo 1258",
    width: 3.069,
    height: 17.498,
    transform: "translate(95.466 39.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_759",
    "data-name": "Caminho 759",
    d: "M840.566,342.7h-8.29l-1.286,3.358h-3.358l6.873-17.5h3.83l6.873,17.5h-3.358Zm-7.424-2.7H839.7l-3.279-8.841Z",
    transform: "translate(-727.21 -288.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_760",
    "data-name": "Caminho 760",
    d: "M0,527.136H7.069v1.388H1.578V531.6h5.38v1.388H1.578v3.282H7.069v1.388H0Z",
    transform: "translate(0 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_761",
    "data-name": "Caminho 761",
    d: "M96.876,533.369,93.72,537.66H91.811l4.039-5.4-3.8-5.128h1.909l2.919,4.039,2.9-4.039h1.909l-3.771,5.112,4.008,5.412h-1.893Z",
    transform: "translate(-80.671 -463.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_762",
    "data-name": "Caminho 762",
    d: "M211.839,527.136h4.434a3.237,3.237,0,1,1,0,6.469h-2.856v4.055h-1.578Zm4.229,1.388h-2.651v3.692h2.651a1.848,1.848,0,1,0,0-3.692",
    transform: "translate(-186.135 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_763",
    "data-name": "Caminho 763",
    d: "M315.48,527.136h7.069v1.388h-5.491V531.6h5.38v1.388h-5.38v3.282h5.491v1.388H315.48Z",
    transform: "translate(-277.201 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_764",
    "data-name": "Caminho 764",
    d: "M419.553,533.605h-1.972v4.055H416V527.136h4.434a3.137,3.137,0,0,1,3.377,3.234,2.936,2.936,0,0,1-2.619,3.077l2.7,4.213h-1.83Zm.679-5.081h-2.651v3.692h2.651a1.849,1.849,0,1,0,0-3.692",
    transform: "translate(-365.526 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1259",
    "data-name": "Ret\\xE2ngulo 1259",
    width: 1.578,
    height: 10.524,
    transform: "translate(63.369 63.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_765",
    "data-name": "Caminho 765",
    d: "M580.507,527.136h7.069v1.388h-5.491V531.6h5.38v1.388h-5.38v3.282h5.491v1.388h-7.069Z",
    transform: "translate(-510.069 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    "data-name": "Caminho 766",
    d: "M682.608,529.582v8.078H681.03V527.136h1.625l5.727,7.889v-7.889h1.578V537.66H688.43Z",
    transform: "translate(-598.395 -463.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_767",
    "data-name": "Caminho 767",
    d: "M796.246,531.149a5.27,5.27,0,0,1,5.4-5.443,4.759,4.759,0,0,1,4.181,2.225l-1.341.71a3.336,3.336,0,0,0-2.84-1.53,4.049,4.049,0,0,0,0,8.078,3.336,3.336,0,0,0,2.84-1.53l1.341.71a4.779,4.779,0,0,1-4.181,2.225,5.27,5.27,0,0,1-5.4-5.444",
    transform: "translate(-699.631 -461.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    "data-name": "Caminho 768",
    d: "M914.193,527.136h7.069v1.388h-5.491V531.6h5.38v1.388h-5.38v3.282h5.491v1.388h-7.069Z",
    transform: "translate(-803.267 -463.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    "data-name": "Caminho 769",
    d: "M400.27,24.227l-3.828,3.828,1.912,1.912-.957.957-.957-.957-.957-.957-1.914,1.914-.957-.957,1.916-1.916h0l-2.87-2.87h0l-2.871,2.871,0,0,1.914,1.914-.955.954-2.871-2.871,4.407-4.407h5.742l-2.492,2.492.957.957,3.449-3.449h0l1.353-1.354H390.72l-5.764,5.764.957.957,0,0,2.871,2.871.957.957.957-.957.955-.955.957.957-.957.957-.957.957,1.914,1.914-.957.957-1.916-1.916h0l-2.87,2.87.957.957.96.96h0l.957.957,1.914-1.914.954.954-2.871,2.871L385.331,38V32.255l2.492,2.492.957-.957-3.449-3.449v0l-1.354-1.353v0h0v9.569h0l5.764,5.764.957-.957,0,0,3.828-3.828-1.912-1.912.957-.957.957.957.957.957,1.914-1.914.957.957-1.917,1.916h0l2.87,2.87,1.916-1.916.955-.955,0,0-1.914-1.914.955-.955,2.871,2.871-4.407,4.407h-5.742l2.492-2.492-.957-.957-3.449,3.449h0L390.674,45.3h9.571l5.764-5.764-.957-.957,0,0-2.871-2.871-.957-.957-.957.957-.955.955-.957-.957.957-.957.957-.957-1.914-1.914.957-.957,1.916,1.916h0l2.87-2.87-.957-.957-.959-.96-.955-.954,0,0-1.914,1.914-.955-.955,2.871-2.871,4.407,4.407v5.742l-2.492-2.492-.957.957,3.449,3.449v0l1.353,1.353v0h0V29.033h0l-5.764-5.764-.957.957ZM390.7,28.052l.96-.959.957.957-.959.959Zm-.957,10.527-.959-.959.957-.957.959.959Zm10.527.957-.959.959-.957-.957.959-.959Zm-4.785-8.613.957.957-.957.957-.957-.957Zm-2.871,2.871.957-.957.957.957-.957.957Zm2.871,2.871-.957-.957.957-.957.957.957Zm2.871-2.871-.957.957-.957-.957.957-.957Zm2.871-4.785.959.959-.957.957-.96-.959Z",
    transform: "translate(-337.385 -19.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_770",
    "data-name": "Caminho 770",
    d: "M381.784,0H370.012l-8.325,8.325V20.1l8.325,8.324h11.772l8.325-8.324V8.325Zm6.971,19.536-7.532,7.532H370.572l-7.532-7.532V8.885l7.532-7.532h10.651l7.532,7.532Z",
    transform: "translate(-317.801)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentiaExperience);
export default __webpack_public_path__ + "static/media/essentia-experience.11dd76992c57e235d8fd671d6591db90.svg";
export { ForwardRef as ReactComponent };